// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/card/card.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, ".defd27{position:relative;z-index:2}.defd27 li{display:flex}.defd27 li+li{margin-top:.5em}.f329cc{font-size:.875em;margin-top:1em}._60affe{font-size:.8em;list-style:disc;padding-left:2em;z-index:inherit}.ecd068{margin-right:1em;font-size:.75em}.ecd068.is-checked~span{text-decoration:line-through;opacity:.35}._5f3f7e{color:var(--secondary)}._8e11d7{margin-top:.5em;color:var(--secondary)}._92b7b1,._6ffb6c{padding-left:.5em}._92b7b1{color:var(--secondary)}", ""]);
// Exports
exports.locals = {
	"list": "defd27",
	"checkList": "f329cc defd27",
	"bulletList": "_60affe " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["spacing"] + " defd27",
	"checkbox": "ecd068",
	"counter": "_5f3f7e",
	"progress": "_8e11d7 " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["progress"] + "",
	"duration": "_92b7b1",
	"time": "_6ffb6c"
};
module.exports = exports;
